import { FilterType } from "@studyportals/omnisearch-interfaces";
import { IExtendedFilterValue } from "@app/interfaces/dtos/IExtendedFilterValue";
import { FilterMapper } from "@app/routing/mappers/FilterMapper";
import { TuitionFeeFilterValue } from "@studyportals/search-api-interface";
import { RouteLocation } from "vue-router";
import {IExtendedWithPortalTypeFilterValue} from "@app/routing/mappers/IExtendedWithPortalTypeFilterValue";
import { SearchType } from "@domain/enums/SearchType";

export class TuitionFeeFilterMapper extends FilterMapper {
	public filterType: FilterType = FilterType.TUITION_FEE;
	public isMultiSelect = false;
	private static instance: TuitionFeeFilterMapper;

	protected values: IExtendedWithPortalTypeFilterValue[] = [
		{ id: TuitionFeeFilterValue.ZERO_TO_TWO_THOUSAND_FIVE_HUNDRED, virtualPath: 'affordable', name: 'Affordable' },
	];

	public static getInstance(): TuitionFeeFilterMapper {
		if (!TuitionFeeFilterMapper.instance) {
			TuitionFeeFilterMapper.instance = new TuitionFeeFilterMapper();
		}
		return TuitionFeeFilterMapper.instance;
	}

	private constructor() {
		super();
	}

	public override allowedInSearchType(searchType?: SearchType): boolean {
		return searchType === SearchType.PROGRAMME_SEARCH;
	}

	protected override getFilterValuesFromRouteQuery(valueSet: Set<IExtendedFilterValue>, route: RouteLocation): Set<IExtendedWithPortalTypeFilterValue> {
		const queryValue = route.query?.[this.filterType];
		if (typeof queryValue === 'string') {
			const value = this.values.find((v) => v.id === queryValue);
			if (value) {
				valueSet.add(value);
			} else {
				const customValue = this.processCustomTuitionFeeValue(queryValue);
				if (customValue) valueSet.add(customValue);
			}
		}

		return valueSet
	}

	private processCustomTuitionFeeValue(value: string): IExtendedWithPortalTypeFilterValue | undefined {
		try {
			const range = JSON.parse(value) as [number, number];
			if(Array.isArray(range) && range.length === 2 && typeof range[0] === 'number' && typeof range[1] === 'number'){
				const customValue: IExtendedWithPortalTypeFilterValue = {
					id: value,
					name: `Range (${range[0]} - ${range[1]})`,
				};

				return customValue;
			}
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
		} catch (e) {
			console.error('Failed to parse tuition fee range:', value);
			return undefined;
		}
	}
}
